import React from 'react'
import { useFragment, graphql } from 'react-relay/hooks'
import { FlexRow, FlexColumn, Select, Text, Button, Icon } from 'elements'
import { blankTemplate } from '../constants'

function changeTemplates({ template, editing, handleTemplateChange }) {
  let canChange = true

  if (editing) {
    canChange = window.confirm(
      'Are you sure you want to switch templates? Your changes will be lost.',
    )
  }

  if (canChange) {
    handleTemplateChange(template)
  }
}

export default function SelectTemplateModalHeader({
  currentTemplate,
  handleTemplateChange,
  onClose,
  onBack,
  editing,
  defaultTemplate,
  organization,
}) {
  const data = useFragment(
    graphql`
      fragment SelectTemplateModalHeader_organization on Organization {
        reportTemplates(orderBy: CREATED_AT_DESC, first: 100)
          @connection(key: "SelectTemplateModalHeader_reportTemplates") {
          edges {
            node {
              id
              name
              config
            }
          }
        }
      }
    `,
    organization,
  )

  const templates = data?.reportTemplates?.edges?.map((edge) => edge.node) || []

  const templateOptions = [
    { label: 'Default', value: defaultTemplate },
    { label: 'New (blank)', value: blankTemplate },
    ...templates.map((template) => ({ label: template.name, value: template })),
  ]

  return (
    <FlexRow justifyContent="space-between" px="xxlarge" py="medium">
      <FlexRow flex="1" justifyContent="start" alignItems="center">
        <Button kind="transparent" area="xxsmall" onPress={onBack} disabled={!onBack} opacity="1">
          {onBack ? <Icon name="arrow-left" color="neutral.2" /> : null}
        </Button>
      </FlexRow>
      <FlexRow alignItems="center" flex="3">
        <FlexColumn flex="1">
          <Text fontWeight="bold">Template:</Text>
        </FlexColumn>
        <FlexColumn flex="1.5">
          <Select
            options={templateOptions}
            value={templateOptions.find((option) => option.value.name === currentTemplate?.name)}
            placeholder="Select Template"
            onChange={(option) =>
              changeTemplates({ template: option.value, editing, handleTemplateChange })
            }
          />
        </FlexColumn>
      </FlexRow>
      <FlexRow flex="1" justifyContent="end" alignItems="center">
        {onClose ? (
          <Button kind="transparent" area="xxsmall" onPress={onClose}>
            <Icon name="x" color="neutral.2" />
          </Button>
        ) : null}
      </FlexRow>
    </FlexRow>
  )
}
